import { makeStyles } from '@material-ui/core/styles';
import { PrimaryColors, SecondaryColors, SurfaceColors, TextColors } from '@/utils/constants';

const lightTheme = {
  root: {
    '& $squareBox': {
      backgroundColor: SurfaceColors.light,
      color: TextColors.dark,
    },
    '& $title': {
      color: TextColors.dark,
      '&.title-blue': {
        color: SecondaryColors.dark,
      },
    },
  },
};

const darkTheme = {
  root: {
    '& $squareBox': {
      backgroundColor: PrimaryColors.light,
      color: TextColors.light,
    },
    '& $title': {
      color: TextColors.light,
      '&.title-blue': {
        color: SecondaryColors.main,
      },
    },
  },
};

const useStyles = makeStyles(
  (muiTheme) => ({
    root: {
      width: '100%',
      '&.light-theme': lightTheme.root,
      '&.dark-theme': darkTheme.root,
    },
    title: {
      '&.MuiTypography-root': {
        display: 'block',
        marginBottom: '20px',
      },
    },
    row: {
      display: 'flex',
      '& .MuiGrid-spacing-xs-5 > .MuiGrid-item': {
        padding: '10px',
        [muiTheme.breakpoints.up('md')]: {
          padding: '20px',
        },
      },
    },
    column: {
      padding: '0 20px',
    },
    squareBox: {
      padding: '50px',
      textAlign: 'center',
    },
  }),
  { name: 'GenSquareTileCTA' },
);

export default useStyles;
